import React from "react";
import { Training } from "../../types/Training";
import { Grid, makeStyles, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import Document from "../../types/Document";
import DocumentGroup from "../../types/DocumentGroup";

interface IProps {
  training: Training[];
  documents: Document[];
  packets: DocumentGroup[];
  onRemoveTraining: (training: Training) => void;
  onRemoveDocument: (document: Document) => void;
  onRemovePacket: (document: DocumentGroup) => void;
}
export default function TrainingSelectionViewer(props: IProps) {
  const {
    training,
    documents,
    packets,
    onRemoveTraining,
    onRemoveDocument,
    onRemovePacket
  } = props;
  const classes = useStyles();
  return (
    <>
      <div className={classes.container}>
        <div className={classes.selected}>
          {training.length + documents.length + packets.length} items selected:
        </div>
        <Grid container spacing={2}>
          {training && training.length > 0 ? (
            <>
              {training.map(t => (
                <Grid item xs={12} md={6} key={t.trainingId}>
                  <div className={classes.listItem}>
                    <IconButton
                      className="close-button"
                      onClick={() => onRemoveTraining(t)}
                    >
                      <CloseIcon />
                    </IconButton>
                    <div className={classes.listText}>{t.trainingTitle}</div>
                  </div>
                </Grid>
              ))}
            </>
          ) : null}

          {documents && documents.length > 0 ? (
            <>
              {documents.map(d => (
                <Grid item xs={12} md={6} key={d.documentId}>
                  <div className={classes.listItem}>
                    <IconButton
                      className="close-button"
                      onClick={() => onRemoveDocument(d)}
                    >
                      <CloseIcon />
                    </IconButton>
                    <div className={classes.listText}>{d.documentName}</div>
                  </div>
                </Grid>
              ))}
            </>
          ) : null}

          {packets && packets.length > 0 ? (
            <>
              {packets.map(p => (
                <Grid item xs={12} md={6} key={p.groupId}>
                  <div className={classes.listItem}>
                    <IconButton
                      className="close-button"
                      onClick={() => onRemovePacket(p)}
                    >
                      <CloseIcon />
                    </IconButton>
                    <div className={classes.listText}>{p.groupName}</div>
                  </div>
                </Grid>
              ))}
            </>
          ) : null}
        </Grid>
      </div>
    </>
  );
}

const useStyles = makeStyles({
  container: {
    margin: 30
  },
  selected: {
    fontSize: 14,
    margin: "30px 0 18px 0",
    textTransform: "uppercase"
  },
  listItem: {
    display: "flex",
    alignItems: "center"
  },
  listText: {
    marginLeft: 12,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  closeButton: {}
});
